<template>
  <v-container fluid>
    <v-card class="shadowCard mt-6">

      <!-- Sección principal, el header de mi componente -->
      <v-card-title class="text-subtitle-1">

        <!-- Titulo de mi componente -->
        Estado de Cuenta Bancos Detalle
        <v-spacer></v-spacer>

        <v-btn
          color="success"
          small
          dark
          class="mr-2"
          :loading="exportando"
          @click="exportarExcelBancos()"
        >
          Excel
          <v-icon right>mdi-file-excel</v-icon>
        </v-btn>
        
        <!-- Botón para actualizar la plataforma -->
        <v-btn 
          color="primary"
          small
          dark
          @click="getReportesBancos( )"
        >
          Actualizar
          <v-icon right>mdi-update</v-icon>
        </v-btn>

      </v-card-title>


      <!-- Cuerpo de mi componente -->
      <v-card-text>

        <!-- Filtros principales -->
        <v-row justify="space-between">

          <!-- Filtro por banco -->
          <v-col cols="12" md="4" lg="3">
            <v-select
              v-model="bancoFilter"
              :items="bancoOptions"
              item-text="text"
              item-value="value"
              label="Banco"
              hide-details
              dense
              clearable
              filled
            ></v-select>
          </v-col>

          <!-- FILTRO POR TIPO -->
          <v-col cols="12" md="4" lg="3">
            <v-select
              v-model="tipoArchivo"
              :items="tiposArchivos"
              item-text="text"
              item-value="value"
              label="Tipo"
              hide-details
              dense
              clearable
              filled
            ></v-select>
          </v-col>

          <!-- Filtro por escuela -->
          <v-col cols="12" md="4" lg="3">
            <v-select
              v-model="escuelaFilter"
              :items="escuelaOptions"
              label="Escuela"
              hide-details
              dense
              clearable
              filled
              item-text="text"
              item-value="value"
            ></v-select>
          </v-col>

          <v-col cols="12" sm="4" lg="3" xl="2">
            <v-text-field
              label="Fecha de incio"
              filled
              dense
              hide-details
              clearable
              v-model="fechaini"
              type="date"
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="4" lg="3" xl="2">
            <v-text-field
              label="Fecha final"
              filled
              dense
              hide-details
              clearable
              v-model="fechafin"
              type="date"
            ></v-text-field>
          </v-col>

        </v-row>

        <!-- Apartado: Agregar saldo de la cuenta al día por escuela -->
        <v-row>
          <v-col cols="12">
            <v-alert
              type="info"
              outlined
              dense
              class="mb-0"
            >
              <span class="text-body-2">— Agregar saldo de la cuenta al día por escuela</span>
            </v-alert>
          </v-col>
        </v-row>
        
        <v-row>

          <v-col cols="12" md="6">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Buscar"
              single-line
              hide-details
              filled
            ></v-text-field>
          </v-col>

          <v-col cols="12">

            <!-- Botón para validación multiple -->
            <!-- <v-btn 
              color="success" 
              outlined 
              v-if="ingresosSeleccionados.length" 
              @click="validacionMultiple( )"
            >
              Validar datos seleccionados
            </v-btn> -->
            
            <v-data-table
              :headers="headersReporte"
              :items="filteredResults"
              :search="search"
              class="elevation-0"
            >

              <!-- Oculta el checkbox del header (select all) -->
              <template v-slot:header.data-table-select></template>

              <!-- Sacar la información del banco -->
              <template v-slot:item.bancoArchivo="{ item }">
                <v-chip
                  small
                  :color="getBancoColor(item.bancoArchivo)"
                  text-color="white"
                  label
                >
                  {{ getBancoLabel(item.bancoArchivo) }}
                </v-chip>
              </template>


              <!-- Mostrar el tipo de archivo -->
              <template v-slot:item.tipoArchivo="{ item }">
                <v-chip
                  small
                  :color="getTipoArchivo(item.tipoArchivo)"
                  text-color="white"
                  label
                >
                  {{ item.tipoArchivo }}
                </v-chip>
              </template>

            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- Snackbar para notificaciones -->
    <v-snackbar v-model="snackbar.show" :color="snackbar.color" :timeout="snackbar.timeout">
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar.show = false">
          Cerrar
        </v-btn>
      </template>
    </v-snackbar>

    <!-- Dialog de carga -->
    <Alerta v-if="respuestaAlerta" :parametros="parametros" />
    <carga v-if="cargar" />

  </v-container>
</template>

<script>
import axios from 'axios';
import * as XLSX from 'xlsx';

// Componentes
import Alerta         from "@/components/alertas/Alerta.vue";
import carga          from "@/components/alertas/carga.vue";
import validarErrores from "@/mixins/validarErrores";
import funcionesExcel from "@/mixins/funcionesExcel";
import { mapGetters } from 'vuex'

/** Alineado a MAX_DIAS_MATCH del API movimientos.corte (tipo=2). */
const MAX_DIAS_MATCH_EXPORT = 14

export default {
  name: 'ValidationPanel',
  data() {
    return {

      // Alertas
      parametros: {
        dialogError: false,
        mensaje: "",
        color: "",
      },

      respuestaAlerta: false,
      loader: true,
      cargar: false,
      exportando: false,

      dialogAddReporte: false,

      tipoArchivo: '',
			tiposArchivos: [
        { text: 'Todos', value: '' },
        { text: 'EDO CUENTA', value: 'EDO CUENTA' },
        { text: 'TPV', value: 'TPV' },
        { text: 'COMERCIO ELECTRONICO', value: 'COMERCIO ELECTRONICO' },
      ],

			bancoArchivo: null,
			bancosArchivos: ['BBVA', 'BANREGIO', 'HSBC'],

      excelIngresos: null,

      // Header estado de cuenta
      headersReporte: [
        { text: 'Fecha'       , value: 'fecha'         },
        { text: 'Banco'       , value: 'bancoArchivo'  },
        { text: 'Tipo'        , value: 'tipoArchivo'   },
        { text: 'Cargo'       , value: 'pago'          },
        { text: 'Abono'       , value: 'banco'         },
        { text: 'Concepto'    , value: 'concepto'      },
        { text: 'refer BNR'   , value: 'refer_bnr'     },

        { text: 'Refer HSBC 1'  , value: 'ref_hsbc_1'  },
        { text: 'Refer HSBC 2'  , value: 'ref_hsbc_2'  },
        { text: 'Refer HSBC 3'  , value: 'ref_hsbc_3'  },
      ],


      // Nuevos filtros
      bancoFilter: '',
      escuelaFilter: 3,

      // Opciones para los nuevos filtros
      bancoOptions: [
        { text: 'Todos', value: '' },
        { text: 'BBVA', value: 'BBVA' },
        { text: 'BANREGIO', value: 'BANREGIO' },
        { text: 'HSBC', value: 'HSBC' },
      ],
      escuelaOptions: [
        { text: 'Inbi', value: 1 },
        { text: 'Fast', value: 2 },
        { text: 'Todas', value: 3 }
      ],

      excelFile: null,
      loading: false,
      dbData: [],
      processedResults: [],
      search: '',

      snackbar: {
        show: false,
        text: '',
        color: '',
        timeout: 4000
      },

      ingresosSeleccionados:[],

      // Búsqueda desde detalles
      detailSearch: {
        referencia: '',
      },

      archivosLeidos:[],

      fechaini:null,
      fechafin:null,
      

      // LECTURA DE ARCHIVO
      opNomina: 1,
      dialogPDFDetalles: false,

      partidasNomina:[],
      archivoSeleccionado: null,
      dialgoValidaMultiple: false,
      dataMultiple: [],
      RX_ONLY_LEADING_DIGITS: /^\s*(\d+)/,
      RX_SPEI_NOMBRE: /^\s*\d{3}\s+\d+\s+(.+?)\s*$/,
      GENERICOS: new Set(['sin informacion', 'sin información', 'transferencia', 'pago', 'deposito', 'depósito', 'abono', 'sin datos', 'n/a', 'pendiente', 'traspaso', 'traspaso interno'])
    }
  },

  components: {
    Alerta,
    carga,
  },

  watch:{

    archivoSeleccionado ( value ){

      if( value ){

        this.archivosLeidosDetalle = value.detalles
      
        this.processExcel( )
      
      }
    }

  },


  created( ) {

  },

  mixins: [validarErrores, funcionesExcel],

  computed: {

    ...mapGetters('login', ['getdatosUsuarioERPERP']),

    filteredResults() {
      let results = this.archivosLeidos

      // Filtrar por banco
      if ( this.bancoFilter) {
        results = results.filter( item => item.bancoArchivo == this.bancoFilter );
      }

      if( this.tipoArchivo ){
        results = results.filter( item => item.tipoArchivo == this.tipoArchivo );
      }

      // Filtrar por escuela (1=Inbi, 2=Fast, 3 o null=Todas) — campo real: opEscuela
      if ( this.escuelaFilter != null && this.escuelaFilter !== '' && this.escuelaFilter !== 3 ) {
        results = results.filter( item =>
          Number(item.opEscuela || item.escuela || item.id_escuela) === Number(this.escuelaFilter)
        );
      }

      return results;
    },
  },

  methods: {

    ymdAddDays(ymd, days) {
      const [y, m, d] = String(ymd).split('-').map(Number)
      const dt = new Date(y, m - 1, d)
      dt.setDate(dt.getDate() + days)
      const yy = dt.getFullYear()
      const mm = String(dt.getMonth() + 1).padStart(2, '0')
      const dd = String(dt.getDate()).padStart(2, '0')
      return `${yy}-${mm}-${dd}`
    },

    /** Tramos de máximo 15 días calendario (diff ≤ 14) para movimientos.corte tipo=2. */
    tramosMatch(fechaini, fechafin) {
      const tramos = []
      let cursor = fechaini
      while (cursor <= fechafin) {
        let fin = this.ymdAddDays(cursor, MAX_DIAS_MATCH_EXPORT)
        if (fin > fechafin) fin = fechafin
        tramos.push({ inicio: cursor, fin })
        if (fin >= fechafin) break
        cursor = this.ymdAddDays(fin, 1)
      }
      return tramos
    },

    /**
     * Mapa idexcel_ingresos_detalles → { encontrado, folios }
     * Incluye match normal y match de hermanos (estatus == 2 de movimientos.corte).
     */
    mapaMatchesPorBanco(movimientos) {
      const map = {}
      for (const mov of movimientos || []) {
        if (!mov || !mov.dbData) continue
        if (Number(mov.estatus) !== 2) continue
        const idExcel = mov.dbData.idexcel_ingresos_detalles
        if (idExcel == null || idExcel === '') continue

        let ids = []
        if (mov.match_hermanos) {
          const grupo = Array.isArray(mov.hermanos_grupo) ? mov.hermanos_grupo : []
          ids = grupo.map((h) => h && h.id_ingreso).filter((id) => id != null)
          if (!ids.length && mov.id_ingreso != null) ids = [mov.id_ingreso]
        } else if (mov.id_ingreso != null) {
          ids = [mov.id_ingreso]
        }
        if (!ids.length) continue

        if (!map[idExcel]) {
          map[idExcel] = { ids: [] }
        }
        for (const id of ids) {
          if (!map[idExcel].ids.includes(id)) map[idExcel].ids.push(id)
        }
      }

      const out = {}
      for (const key of Object.keys(map)) {
        const ids = map[key].ids || []
        out[key] = {
          encontrado: ids.length > 0,
          folios: ids.length ? ids.join(', ') : '',
        }
      }
      return out
    },

    async cargarMatchesExport(fechaini, fechafin) {
      const tramos = this.tramosMatch(fechaini, fechafin)
      const hoy = new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10)
      const mapa = {}
      for (const t of tramos) {
        const response = await this.$http.post('movimientos.corte', {
          id_ciclo: null,
          // Banco: solo el tramo exportado
          fecha_inicio: t.inicio,
          fecha_final: t.fin,
          tipo: 2,
          mapa_export_bancos: true,
          // Ingresos: tramo del banco + 7 días de captura tardía (no hasta hoy).
          fecha_ingresos_inicio: fechaini,
          fecha_ingresos_fin: (() => {
            const tope = this.ymdAddDays(fechafin, 7)
            return tope && hoy && tope > hoy ? hoy : (tope || fechafin)
          })(),
        })
        const data = response && response.data
        const parcial = data && data.mapa ? data.mapa : null
        if (!parcial || typeof parcial !== 'object') continue
        for (const key of Object.keys(parcial)) {
          const row = parcial[key] || {}
          const montosSrc = row.montos && typeof row.montos === 'object' ? row.montos : null
          if (!mapa[key]) {
            mapa[key] = { montosById: {}, escuelasById: {}, plantelesById: {} }
          }
          const escuelasSrc = row.escuelas && typeof row.escuelas === 'object' ? row.escuelas : null
          const plantelesSrc = row.planteles && typeof row.planteles === 'object' ? row.planteles : null
          if (escuelasSrc) {
            for (const idKey of Object.keys(escuelasSrc)) {
              if (!mapa[key].escuelasById[idKey] && escuelasSrc[idKey]) {
                mapa[key].escuelasById[idKey] = escuelasSrc[idKey]
              }
            }
          }
          if (plantelesSrc) {
            for (const idKey of Object.keys(plantelesSrc)) {
              if (!mapa[key].plantelesById[idKey] && plantelesSrc[idKey]) {
                mapa[key].plantelesById[idKey] = plantelesSrc[idKey]
              }
            }
          }
          if (montosSrc) {
            for (const idKey of Object.keys(montosSrc)) {
              const monto = Number(montosSrc[idKey])
              if (!Number.isFinite(monto)) continue
              if (mapa[key].montosById[idKey] == null) {
                mapa[key].montosById[idKey] = monto
              }
            }
          } else {
            const foliosStr = row.folios != null ? String(row.folios) : ''
            const ids = foliosStr
              ? foliosStr.split(',').map((s) => String(s).trim()).filter(Boolean)
              : []
            const pagadoRow = Number(row.pagado)
            for (let i = 0; i < ids.length; i++) {
              if (mapa[key].montosById[ids[i]] == null && Number.isFinite(pagadoRow) && ids.length === 1) {
                mapa[key].montosById[ids[i]] = pagadoRow
              } else if (mapa[key].montosById[ids[i]] == null) {
                mapa[key].montosById[ids[i]] = 0
              }
              if (!mapa[key].escuelasById[ids[i]] && row.escuela_alumno) {
                mapa[key].escuelasById[ids[i]] = row.escuela_alumno
              }
              if (!mapa[key].plantelesById[ids[i]] && row.plantel) {
                mapa[key].plantelesById[ids[i]] = row.plantel
              }
            }
          }
        }
      }
      const unicosJoin = (obj) => [...new Set(Object.values(obj || {}).filter(Boolean))].join(', ')
      const out = {}
      for (const key of Object.keys(mapa)) {
        const montosById = mapa[key].montosById || {}
        const ids = Object.keys(montosById)
        let pagado = 0
        for (let i = 0; i < ids.length; i++) {
          pagado += Number(montosById[ids[i]]) || 0
        }
        out[key] = {
          encontrado: ids.length > 0,
          folios: ids.join(', '),
          pagado: Math.round(pagado * 100) / 100,
          escuela_alumno: unicosJoin(mapa[key].escuelasById),
          plantel: unicosJoin(mapa[key].plantelesById),
        }
      }
      return out
    },

    hojaExportBanco(item) {
      const tipo = String((item && item.tipoArchivo) || '').toUpperCase()
      const esc = Number((item && (item.opEscuela != null ? item.opEscuela : (item.escuela != null ? item.escuela : item.id_escuela))))
      if (tipo === 'TPV') {
        return esc === 2 ? 'Tarjeta FAST' : 'Tarjeta INBI'
      }
      if (tipo === 'COMERCIO ELECTRONICO') {
        return esc === 2 ? 'Ecommerce FAST' : 'Ecommerce INBI'
      }
      return esc === 2 ? 'FAST' : 'INBI'
    },

    diferenciaEfectivoExport(item, matchRow) {
      if (!matchRow || !matchRow.encontrado) return ''
      const abono = Number(item && item.banco)
      const pagado = Number(matchRow.pagado)
      if (!Number.isFinite(abono) || !Number.isFinite(pagado)) return ''
      return Math.round((abono - pagado) * 100) / 100
    },

    mapaFilaExcelBanco(item, matchesMap) {
      const idExcel = item && item.idexcel_ingresos_detalles
      const m = idExcel != null && matchesMap
        ? (matchesMap[idExcel] || matchesMap[String(idExcel)] || null)
        : null
      return {
        Fecha: item.fecha || '',
        Banco: this.getBancoLabel(item.bancoArchivo),
        Tipo: item.tipoArchivo || '',
        Cargo: item.pago != null ? item.pago : '',
        Abono: item.banco != null ? item.banco : '',
        Concepto: item.concepto || '',
        'refer BNR': item.refer_bnr || '',
        'Refer HSBC 1': item.ref_hsbc_1 || '',
        'Refer HSBC 2': item.ref_hsbc_2 || '',
        'Refer HSBC 3': item.ref_hsbc_3 || '',
        Escuela: Number(item.opEscuela) === 1 ? 'INBI' : (Number(item.opEscuela) === 2 ? 'FAST' : ''),
        Encontrado: m && m.encontrado ? 'encontrado' : '',
        Folios: m ? m.folios : '',
        'Escuela alumno': m && m.escuela_alumno ? m.escuela_alumno : '',
        Plantel: m && m.plantel ? m.plantel : '',
        'Diferencia de efectivo': this.diferenciaEfectivoExport(item, m),
      }
    },

    appendHojaExcel(workbook, nombre, filas) {
      const sheetName = String(nombre || 'Hoja').slice(0, 31)
      if (!filas || !filas.length) {
        XLSX.utils.book_append_sheet(
          workbook,
          XLSX.utils.aoa_to_sheet([['Sin movimientos en esta hoja']]),
          sheetName
        )
        return
      }
      const ordenadas = this.ordenarFilasPorBanco(filas)
      XLSX.utils.book_append_sheet(
        workbook,
        XLSX.utils.aoa_to_sheet(this.filasBancoConSeparador(ordenadas)),
        sheetName
      )
    },

    /** Orden: Banco → Fecha → Concepto. */
    ordenarFilasPorBanco(filas) {
      return (filas || []).slice().sort((a, b) => {
        const ba = String((a && a.Banco) || '').localeCompare(String((b && b.Banco) || ''), 'es')
        if (ba !== 0) return ba
        const fa = String((a && a.Fecha) || '').localeCompare(String((b && b.Fecha) || ''))
        if (fa !== 0) return fa
        return String((a && a.Concepto) || '').localeCompare(String((b && b.Concepto) || ''), 'es')
      })
    },

    /** AOA con encabezados y fila en blanco al cambiar de banco. */
    filasBancoConSeparador(filas) {
      const headers = [
        'Fecha',
        'Banco',
        'Tipo',
        'Cargo',
        'Abono',
        'Concepto',
        'refer BNR',
        'Refer HSBC 1',
        'Refer HSBC 2',
        'Refer HSBC 3',
        'Escuela',
        'Encontrado',
        'Folios',
        'Escuela alumno',
        'Plantel',
        'Diferencia de efectivo',
      ]
      const aoa = [headers]
      let lastBanco = null
      for (let i = 0; i < (filas || []).length; i++) {
        const row = filas[i] || {}
        const banco = row.Banco || ''
        if (lastBanco !== null && banco !== lastBanco) {
          aoa.push([])
        }
        lastBanco = banco
        aoa.push(headers.map((h) => (row[h] != null ? row[h] : '')))
      }
      return aoa
    },

    async exportarExcelBancos() {
      if (!this.fechaini || !this.fechafin) {
        return this.validarErrorDirecto('Por favor ingresa un rango de fechas')
      }
      if (!this.archivosLeidos.length) {
        await this.getReportesBancos()
      }
      const filas = this.filteredResults || []
      if (!filas.length) {
        return this.validarErrorDirecto('No hay resultados para exportar con los filtros seleccionados')
      }

      this.exportando = true
      this.cargar = true
      try {
        const matchesMap = await this.cargarMatchesExport(this.fechaini, this.fechafin)
        const inbi = []
        const fast = []
        const tarjetaInbi = []
        const tarjetaFast = []
        const ecommerceInbi = []
        const ecommerceFast = []
        for (let i = 0; i < filas.length; i++) {
          const item = filas[i]
          const row = this.mapaFilaExcelBanco(item, matchesMap)
          const hoja = this.hojaExportBanco(item)
          if (hoja === 'Tarjeta FAST') tarjetaFast.push(row)
          else if (hoja === 'Tarjeta INBI') tarjetaInbi.push(row)
          else if (hoja === 'Ecommerce FAST') ecommerceFast.push(row)
          else if (hoja === 'Ecommerce INBI') ecommerceInbi.push(row)
          else if (hoja === 'FAST') fast.push(row)
          else inbi.push(row)
        }

        const workbook = XLSX.utils.book_new()
        const escuela = Number(this.escuelaFilter)
        const incluirInbi = escuela !== 2
        const incluirFast = escuela !== 1
        if (incluirInbi) {
          this.appendHojaExcel(workbook, 'INBI', inbi)
          this.appendHojaExcel(workbook, 'Tarjeta INBI', tarjetaInbi)
          this.appendHojaExcel(workbook, 'Ecommerce INBI', ecommerceInbi)
        }
        if (incluirFast) {
          this.appendHojaExcel(workbook, 'FAST', fast)
          this.appendHojaExcel(workbook, 'Tarjeta FAST', tarjetaFast)
          this.appendHojaExcel(workbook, 'Ecommerce FAST', ecommerceFast)
        }

        const ini = this.fechaini || ''
        const fin = this.fechafin || ''
        const filename = ('estado_cuenta_bancos_' + ini + '_' + fin).replace(/[^a-zA-Z0-9_-]/g, '_')
        XLSX.writeFile(workbook, filename + '.xlsx')
      } catch (error) {
        let msg = 'Ocurrió un error al exportar el Excel.'
        if (error && error.response && error.response.data && error.response.data.message) {
          msg = error.response.data.message
        }
        this.validarError(msg)
      } finally {
        this.exportando = false
        this.cargar = false
      }
    },

    getBancoColor(banco) {
      if (!banco) return 'grey';

      const bancoUpper = banco.toString().toUpperCase();
      if (bancoUpper.includes('BBVA') || bancoUpper.includes('BANCOMER')) return 'blue darken-1';
      if (bancoUpper.includes('BR') || bancoUpper.includes('BANREGIO')) return 'purple';
      if (bancoUpper.includes('SANTANDER')) return 'red darken-1';
      if (bancoUpper.includes('BANAMEX') || bancoUpper.includes('CITI')) return 'blue-grey';
      if (bancoUpper.includes('BANORTE')) return 'orange darken-1';
      if (bancoUpper.includes('HSBC')) return 'red';

      return 'green'; // Para otros bancos
    },

    getTipoArchivo(tipo) {
      if (!tipo) return 'grey';

      const bancoUpper = tipo.toString().toUpperCase();
      if (bancoUpper.includes('EDO CUENTA') || bancoUpper.includes('BANCOMER')) return 'green';
      if (bancoUpper.includes('TPV') || bancoUpper.includes('BANREGIO')) return 'purple';
      if (bancoUpper.includes('COMERCIO ELECTRONICO')) return 'yellow';

      return 'green'; // Para otros bancos
    },

    getBancoLabel(banco) {
      if (!banco) return 'N/A';

      const bancoUpper = banco.toString().toUpperCase();
      if (bancoUpper.includes('BBVA') || bancoUpper.includes('BANCOMER')) return 'BBVA';
      if (bancoUpper.includes('BR') || bancoUpper.includes('BANREGIO')) return 'BanRegio';
      if (bancoUpper.includes('SANTANDER')) return 'Santander';
      if (bancoUpper.includes('BANAMEX') || bancoUpper.includes('CITI')) return 'Banamex';
      if (bancoUpper.includes('BANORTE')) return 'Banorte';
      if (bancoUpper.includes('HSBC')) return 'HSBC';

      return banco; // Para otros bancos, mostrar el valor original
    },

    async getReportesBancos( ){

      this.cargar = true
      
      this.archivosLeidos = []
      // /*Initialize the form data*/
      

      if( !this.fechaini || !this.fechafin ){
      	return this.validarErrorDirecto('Porfavor ingresa un rango de fechas')
      }

      try {

      	let payload = {
      		fechaini: this.fechaini,
					fechafin: this.fechafin
      	}

        const response = await this.$http.post('reportes.bancos.detalles', payload);
        this.archivosLeidos = response.data

      } catch (error) {
        // 🔹 8. Manejo seguro del error (sin optional chaining)
        let msg = 'Ocurrió un error al procesar el archivo. Intente de nuevo.';

        if (
          error &&
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          msg = error.response.data.message;
        }

        this.validarError(msg);

      } finally {
        // 🔹 9. Apagamos el loader siempre
        this.cargar = false;
      }

    },

  }
};
</script>

<style scoped>
.max-width-200 {
  max-width: 200px;
}
.text-success {
  color: #4caf50 !important;
}
.text-error {
  color: #f44336 !important;
}
.text-warning {
  color: #fb8c00 !important;
}
.cursor-pointer {
  cursor: pointer;
}
.text-wrap {
  white-space: normal;
  word-break: break-word;
  display: block;
}
.concepto-container {
  font-family: monospace;
  white-space: pre-wrap;
  word-break: break-all;
  user-select: all;
  cursor: text;
}
</style>
